import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_3 = { class: "alert-heading mb-2" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_8 = { class: "alert-heading mb-2" }
const _hoisted_9 = { class: "mb-0 small" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_12 = { class: "alert-heading mb-2" }
const _hoisted_13 = { class: "mb-0 small" }
const _hoisted_14 = {
  key: 0,
  class: "mb-3 mt-3 fraudex-comments"
}
const _hoisted_15 = { class: "fraudex-comments__title mb-3" }
const _hoisted_16 = { class: "fraudex-comments__list" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "form-check" }
const _hoisted_19 = {
  class: "form-check-label",
  for: "riskConfirmation"
}
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', $event))),
    "dialog-class": "modal-lg",
    title: _ctx.helper.trans('fraudex.check_result'),
    "body-class": "pt-3"
  }, {
    default: _withCtx(() => [
      (_ctx.fraudexCheck)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.fraudexCheck.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("h6", _hoisted_3, [
                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('fraudex.check_error')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.fraudexCheck.error), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.fraudexCheck.isBlacklisted === false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h6", _hoisted_8, [
                            _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-check-circle me-2" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('fraudex.not_in_blacklist')), 1)
                          ]),
                          _createElementVNode("p", _hoisted_9, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans('labels.requisites')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.fraudexCheck.requisite), 1)
                          ])
                        ])
                      ]))
                    : (_ctx.fraudexCheck.isBlacklisted === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("h6", _hoisted_12, [
                              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('fraudex.in_blacklist')), 1)
                            ]),
                            _createElementVNode("p", _hoisted_13, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.helper.trans('labels.requisites')) + ":", 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.fraudexCheck.requisite), 1)
                            ])
                          ]),
                          (_ctx.fraudexCheck.comments && _ctx.fraudexCheck.comments.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("h6", _hoisted_15, _toDisplayString(_ctx.helper.trans('fraudex.comments')) + ":", 1),
                                _createElementVNode("ul", _hoisted_16, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fraudexCheck.comments, (comment, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: index,
                                      class: "fraudex-comments__item"
                                    }, _toDisplayString(comment), 1))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.riskConfirmed) = $event)),
                                id: "riskConfirmation"
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.riskConfirmed]
                              ]),
                              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.helper.trans('fraudex.confirm_risks')), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel'))),
        class: "btn btn-outline-secondary btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('continue'))),
        disabled: _ctx.fraudexCheck && !_ctx.fraudexCheck.error && _ctx.fraudexCheck.isBlacklisted === true && !_ctx.riskConfirmed,
        class: "btn btn-outline-primary btn-sm text-capitalize-first"
      }, [
        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fa fa-check me-2" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.continue')), 1)
      ], 8, _hoisted_20)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}